import { Input, Popover } from "antd";
import { Form as AntForm } from "antd";
import { InputProps } from "antd/lib/input";
import React, { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styles from "./password.module.css";
import cx from "classnames";
import "./textField.css";

const Item = AntForm.Item;

export interface Props extends Omit<InputProps, "value"> {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | null;
  onBlur?: () => void;
  helperText?: string;
  disabled?: boolean;
  label?: ReactNode;
  error?: boolean;
  name: string;
  showPasswordRequirement?: boolean;
}

export const TextField: FC<Props> = ({
  error,
  label,
  helperText,
  showPasswordRequirement,
  ...props
}) => {
  const { t } = useTranslation();

  const placement = window.innerWidth > 1300 ? "right" : "top";

  return (
    <Item
      colon={false}
      help={helperText} // TODO: inspect this magic "::" - why one is removed
      label={!!label ? `${label}:` : undefined}
      labelCol={{ span: 24 }}
      validateStatus={error ? "error" : undefined}
    >
      {showPasswordRequirement ? (
        <Popover
          autoAdjustOverflow={false}
          content={
            <div className={cx(styles.pwReqContainer, placement === "top" && styles.top)}>
              <div className={styles.pwReqTitle}>
                {t("PLEASE_CREATE_A_PASSWORD_THAT_MEETS_ALL_THE_REQUIREMENTS_BELOW")}
              </div>
              <ul className={styles.pwReqUl}>
                <li>{t("MIN_CHARACTERS_IN_LENGTH", { min: 12 })}</li>
                <li>{t("MUST_INCLUDE_AT_LEAST_ONE_UPPERCASE_LETTER")}</li>
                <li>{t("MUST_INCLUDE_AT_LEAST_ONE_LOWERCASE_LETTER")}</li>
                <li>{t("MUST_INCLUDE_AT_LEAST_ONE_NUMBER")}</li>
                <li>
                  <span>{t("MUST_INCLUDE_AT_LEAST_ONE_SPECIAL_CHARACTER")}</span>
                  <span className={styles.specialChar}>{"\\"}</span>
                  <span className={styles.specialChar}>{'"'}</span>
                  <span className={styles.specialChar}>{","}</span>
                  <span className={styles.specialChar}>{"'"}</span>
                </li>
              </ul>
            </div>
          }
          placement={placement}
          trigger="click"
        >
          {/* @ts-ignore TODO: ... */}
          <Input {...props} />
        </Popover>
      ) : (
        // @ts-ignore TODO: ...
        <Input {...props} />
      )}
    </Item>
  );
};
